import { create } from "zustand";
import { WrapperParams } from "../../../Shared/Types/GroupEntry.types";

type PostListModalStoreType = {
    isPostListModalOpen: boolean;
    selectedGroupId: number | undefined;
    postListAction: WrapperParams | undefined;
    setIsPostListModalOpen: (open: boolean, groupId?: number) => void;
    setPostListAction: (actionParams?: WrapperParams) => void;
};

export const usePostListModalStore = create<PostListModalStoreType>()(
    (set) => ({
        isPostListModalOpen: false,
        setIsPostListModalOpen: (open, groupId) => {
            set({
                isPostListModalOpen: open,
                selectedGroupId: groupId,
            });
        },
        setPostListAction: (actionParams) => {
            set({
                postListAction: actionParams,
            });
        },
        selectedGroupId: undefined,
        postListAction: undefined,
    }),
);
